import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ad1 from '../../assets/communityAds/ad1.png'
import ad2 from '../../assets/communityAds/ad2.png'
import ad3 from '../../assets/communityAds/ad3.png'
import ad4 from '../../assets/communityAds/ad4.png'

export const FeedAdvert = ({ adCode, imageIndex = 1, aiTitle }) => {
  const dispatch = useDispatch()
  const isAuthenticated = useSelector(state => state?.auth?.isAuthenticated)
  const haveMembership = useSelector(state => state.profile?.me?.haveMembership)

  const communityAds = [ad1, ad2, ad3, ad4]
  const selectedAd = useMemo(() => {
    // imageIndex is 1-based, convert to 0-based array index
    const index = (imageIndex - 1) % communityAds.length
    return communityAds[index]
  }, [imageIndex])

  if (haveMembership) return null

  const openPurchaseSidebar = () => {
    window.open('https://decormatters.app.link/jRBbXCsXVQb', '_blank')
  }

  return (
    <img
      src={selectedAd}
      alt={aiTitle || 'Community Ad'}
      onClick={openPurchaseSidebar}
      style={{
        cursor: 'pointer',
        maxWidth: '100%',
        height: '100%',
        display: 'block',
        borderRadius: '10px',
        objectFit: 'cover'
      }}
    />
  )
}
